<template>
  <div>
    <div class="cuadro" @click="defineBox()">
      <img v-if="tipo === 'asiento' && pantalla === false" src="/img/layout/asiento.png" class="centrado" @click="defineAsiento()">
      <img v-if="tipo === 'asiento' && pantalla === true" src="/img/layout/asientotv.png" class="centrado" @click="defineAsiento()">
      <div class="text-center">
        <span class="numeroAsiento" v-if="numeroAsiento > 0">{{numeroAsiento}}|{{categoriaAsiento}}</span>
      </div>

      <img v-if="banoTipo === 'Mixto'" src="/img/layout/mixto.png" class="centrado" @click="defineBano()">
      <img v-if="banoTipo === 'Hombres'" src="/img/layout/hombres.png" class="centrado" @click="defineBano()">
      <img v-if="banoTipo === 'Mujeres'" src="/img/layout/mujeres.png" class="centrado" @click="defineBano()">

      <img v-if="tipo === 'escalera'" src="/img/layout/escalera.png" class="centrado" @click="defineEscalera()">
      <img v-if="tipo === 'operador'" src="/img/layout/operador.png" class="centrado" @click="defineOperador()">
      <img v-if="tipo === 'television'" src="/img/layout/television.png" class="centrado" @click="defineTV()">
      <img v-if="tipo === 'cafeteria'" src="/img/layout/cafeteria.png" class="centrado" @click="defineCafeteria()">

    </div>
    <!-- MODAL DEFINE CUADRO -->
    <modal :show.sync="showDefineBox" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Definición cuadro</h6>
      <div class="text-center">
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxAsiento">Convertir en asiento</button>
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxBano">Convertir en baño</button>
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxEscalera">Convertir en escalera</button>
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxOperador">Convertir en operador</button>
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxCafeteria">Convertir en cafetería</button>
        <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="defineBoxTV">Convertir en televisón</button>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </div>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeDefineBox">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE ASIENTO -->
    <modal :show.sync="showDefineBoxAsiento" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Asiento</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxAsiento">Eliminar Asiento</button>
        </div>
        <base-input label="Número de asiento"
          placeholder="Número de asiento"
          v-model="numero"
          input-classes="form-control-alternative new-event--title">
        </base-input>
        <span v-if="error != null">
          <small class="argon-error" v-text="error"/>
        </span>
        <base-input label="Seleccione una categoría">
          <multiselect v-if="categorias" v-model="categoria" :options="categorias" placeholder="Selecccione una categoría" label="nombre" track-by="id" :showLabels="false"></multiselect>
        </base-input>
        <span v-if="errorCategoria != null">
          <small class="argon-error" v-text="errorCategoria"/>
        </span>
        <base-input label="Tiene pantalla?">
          <base-switch v-model="pantalla" class="mr-1"></base-switch>
        </base-input>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-default hover-apolo new-event--add" @click="addDefineBoxAsiento">Guardar</button>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineAsiento">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE BAÑO -->
    <modal :show.sync="showDefineBoxBano" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Baño</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxBano">Eliminar Baño</button>
        </div>
        <base-input label="Seleccione un tipo de baño">
          <multiselect v-model="bano" :options="banos" placeholder="Selecccione un tipo de baño" label="nombre" track-by="nombre" :showLabels="false"></multiselect>
        </base-input>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-default hover-apolo new-event--add" @click="addDefineBoxBano">Guardar</button>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineBano">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE ESCALERA -->
    <modal :show.sync="showDefineBoxEscalera" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Escalera</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxEscalera">Eliminar Escalera</button>
        </div>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineEscalera">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE OPERADOR -->
    <modal :show.sync="showDefineBoxOperador" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Operador</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxOperador">Eliminar Operador</button>
        </div>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineOperador">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE CAFETERIA -->
    <modal :show.sync="showDefineBoxCafeteria" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Cafetería</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxCafeteria">Eliminar Cafetería</button>
        </div>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineCafeteria">Cerrar</button>
      </template>
    </modal>

    <!-- MODAL DEFINE TV -->
    <modal :show.sync="showDefineBoxTV" :hasParent="true" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Televisón</h6>
        <div class="text-center">
          <button type="button" class="btn btn-primary hover-apolo col-12 ml-0" @click="deleteDefineBoxTV">Eliminar televisión</button>
        </div>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalDefineTV">Cerrar</button>
      </template>
    </modal>
  </div>
  
  
</template>
<script>
import { Modal } from "@/components/";
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Modal, Multiselect,
  },
  props: {
    value: { required: false },
    checkNumeroExists: { required: false },
    addAsiento: { required: false },
    removeAsiento: { required: false },
    layout: { required: false },
    categorias: { required: false },
  },
  data() {
    return {
      showDefineBox: false,
      showDefineBoxAsiento: false,
      showDefineBoxBano: false,
      showDefineBoxEscalera: false,
      showDefineBoxOperador: false,
      showDefineBoxCafeteria: false,
      showDefineBoxTV: false,
      tipo: null,
      numero: null,
      categoria: null,
      pantalla: false,
      bano: null,
      banoTipo: null,
      numeroAsiento: null,
      categoriaAsiento: '',
      pantallaAsiento: null,
      banos: [
        { nombre: 'Mixto'},
        { nombre: 'Hombres'},
        { nombre: 'Mujeres'}
      ],
      error: null,
      errorCategoria: null,
    };
  },
  created() {
    if(!!this.value){
      if(this.value.tipo){
        this.tipo = this.value.tipo;
      }
      if(this.value.tipo === 'asiento'){
        this.numero = this.value.numero;
        this.numeroAsiento = this.value.numero;
        const categoriaNombre = this.value.categoria.nombre;
        this.categoriaAsiento = categoriaNombre.charAt(0);
        this.categoria = this.value.categoria;
        this.pantalla = this.value.pantalla;
      }
      this.banoTipo = this.value.bano;
      if(this.value.bano === 'Mixto'){
        this.bano = this.banos[0];
      }
      if(this.value.bano === 'Hombres'){
        this.bano = this.banos[1];
      }
      if(this.value.bano === 'Mujeres'){
        this.bano = this.banos[2];
      }
    }
  },
  computed: {
  },
  methods: {
    updateModal(){
      const val = {'tipo': this.tipo, 'numero': this.numero, 'categoria': this.categoria, 'pantalla': this.pantalla, 'bano': this.banoTipo};
      this.$emit('input', val);
    },
    defineBox(){
      if(this.tipo === 'asiento' || this.tipo === 'bano' || this.tipo === 'escalera' || this.tipo === 'operador' || this.tipo === 'television' || this.tipo === 'cafeteria'){
        this.showDefineBox = false;
      }else{
        this.showDefineBox = true;
      }
    },
    closeDefineBox(){
      this.showDefineBox = false;
    },
    defineBoxCafeteria(){
      this.tipo = 'cafeteria';
      this.updateModal();
      this.showDefineBox = false;
    },
    defineCafeteria(){
      this.showDefineBoxCafeteria = true;
    },
    deleteDefineBoxCafeteria(){
      this.tipo = null;
      this.updateModal();
      this.showDefineBoxCafeteria = false;
    },
    closeModalDefineCafeteria(){
      this.showDefineBoxCafeteria = false;
    },

    defineBoxTV(){
      this.tipo = 'television';
      this.updateModal();
      this.showDefineBox = false;
    },
    defineTV(){
      this.showDefineBoxTV = true;
    },
    deleteDefineBoxTV(){
      this.tipo = null;
      this.updateModal();
      this.showDefineBoxTV = false;
    },
    closeModalDefineTV(){
      this.showDefineBoxTV = false;
    },

    defineBoxAsiento(){
      this.tipo = 'asiento';
      this.updateModal();
      this.showDefineBox = false;
      this.addAsiento();
    },
    defineAsiento(){
      this.showDefineBoxAsiento = true;
    },
    addDefineBoxAsiento(){
      this.error = null;
      this.errorCategoria = null;
      if(this.numeroAsiento != this.numero){
        const existe = this.checkNumeroExists(this.numero);
        if(existe){
          this.error = 'El número ya ha sido utilizado en otro asiento';
          return;
        }else{
          if(this.categoria != null){
            const categoriaNombre = this.categoria.nombre;
            this.categoriaAsiento = categoriaNombre.charAt(0);
            this.pantallaAsiento = this.pantalla;
            this.numeroAsiento = this.numero;
            this.updateModal();
            this.closeModalDefineAsiento();
          }else{
            this.errorCategoria = 'Es necesario seleccionar una categoría';
            return;
          }
        }
      }else{
        if(this.categoria === null){
          this.errorCategoria = 'Es necesario seleccionar una categoría';
          return;
        }else{
          const categoriaNombre = this.categoria.nombre;
          this.categoriaAsiento = categoriaNombre.charAt(0);
          this.pantallaAsiento = this.pantalla;
          this.numeroAsiento = this.numero;
          this.updateModal();
          this.closeModalDefineAsiento();
        }
      }
    },
    deleteDefineBoxAsiento(){
      this.tipo = null;
      this.numero = null;
      this.categoria = null;
      this.pantalla = false;
      this.numeroAsiento = null;
      this.categoriaAsiento = '';
      this.pantallaAsiento = false;
      this.error = null;
      this.updateModal();
      this.removeAsiento();
      this.showDefineBoxAsiento = false;
    },
    closeModalDefineAsiento(){
      this.showDefineBoxAsiento = false;
    },

    defineBoxBano(){
      this.tipo = 'bano';
      this.bano = this.banos[0];
      this.banoTipo = 'Mixto';
      this.updateModal();
      this.showDefineBox = false;
    },
    defineBano(){
      this.showDefineBoxBano = true;
    },
    addDefineBoxBano(){
      this.banoTipo = this.bano.nombre;
      this.updateModal();
      this.closeModalDefineBano();
    },
    deleteDefineBoxBano(){
      this.tipo = null;
      this.bano = null;
      this.banoTipo = null,
      this.updateModal();
      this.showDefineBoxBano = false;
    },
    closeModalDefineBano(){
      this.showDefineBoxBano = false;
    },

    defineBoxEscalera(){
      this.tipo = 'escalera';
      this.updateModal();
      this.showDefineBox = false;
    },
    defineEscalera(){
      this.showDefineBoxEscalera = true;
    },
    deleteDefineBoxEscalera(){
      this.tipo = null;
      this.updateModal();
      this.showDefineBoxEscalera = false;
    },
    closeModalDefineEscalera(){
      this.showDefineBoxEscalera = false;
    },

    defineBoxOperador(){
      this.tipo = 'operador';
      this.updateModal();
      this.showDefineBox = false;
    },
    defineOperador(){
      this.showDefineBoxOperador = true;
    },
    deleteDefineBoxOperador(){
      this.tipo = null;
      this.updateModal();
      this.showDefineBoxOperador = false;
    },
    closeModalDefineOperador(){
      this.showDefineBoxOperador = false;
    },
  },
  watch: {
    value(newValue) {
      if(!!newValue){
        //this.tipo = newValue.tipo;
      } 
    },
  },
};
</script>
<style scoped>
.cuadro{
      background-color:#fff !important;
      border-width: 0.5px !important;
      border-style:solid !important;
      border-color: #989295 !important;
      height: 60px;
      width: 60px;
    }
    .cuadro:hover{
      background-color:#6074dd !important;
      cursor: pointer;
    }
    .centrado{
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 50px;
      width: 50px;
    }
    .numeroAsiento{
      position:relative;
      bottom: 34px !important;
      font-size: 10px !important;
      right: -2.5px !important;
    }
</style>
<style lang="scss">
    .argon-error {
      position: relative;
      bottom: 25px !important;
      color: #fb6340;
      }
  
</style>

